// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__oL2Mu","contentWrapper":"styles_contentWrapper__1JcZt","textWrapper":"styles_textWrapper__iipKl"};